<template>
  <div>
    <v-row class="mb-2">
      <v-col cols="12" md="4">
        <v-select
          v-model="filterInstructorId"
          :items="instructors"
          item-value="adi_id"
          label="Filter by Instructor"
          outlined
          dense
          clearable
          hide-details
          prepend-inner-icon="mdi-account-tie"
        >
          <template v-slot:item="{ item }">
            <strong>A{{ item.adi_id }}</strong>&nbsp;–&nbsp;{{ item.adi }}
          </template>
          <template v-slot:selection="{ item }">
            A{{ item.adi_id }} – {{ item.adi }}
          </template>
        </v-select>
      </v-col>
    </v-row>

    <v-data-table
      :headers="headers"
      :items="filteredItems"
      :search="search"
      :loading="loading"
      loading-text="Loading enrolments..."
      item-key="enrolment_id"
      class="elevation-1"
      @click:row="$emit('view-progress', $event)"
      style="cursor: pointer"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>Learner Enrolments</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-chip small color="primary" outlined class="mr-3">
            Click a row to view learner progress
          </v-chip>
          <v-text-field
            v-model="search"
            label="Search"
            outlined
            dense
            clearable
            prepend-inner-icon="mdi-magnify"
            style="max-width: 280px"
            hide-details
          ></v-text-field>
        </v-toolbar>
      </template>

      <template v-slot:[`item.learner_id`]="{ item }">
        <strong>L{{ item.learner_id }}</strong>
      </template>

      <template v-slot:[`item.adi_id`]="{ item }">
        <strong>A{{ item.adi_id }}</strong>
      </template>

      <template v-slot:[`item.is_current`]="{ item }">
        <v-chip small :color="item.is_current === 1 ? 'success' : 'grey'" dark>
          {{ item.is_current === 1 ? "Current" : "Inactive" }}
        </v-chip>
      </template>

      <template v-slot:[`item.created_on`]="{ item }">
        {{ item.created_on | dateReOrderRMtime }}
      </template>

      <template v-slot:no-data>
        <v-alert type="info" outlined class="ma-4">
          No enrolments found.
        </v-alert>
      </template>
    </v-data-table>
  </div>
</template>

<script>
export default {
  name: "EnrolmentList",

  props: {
    items: { type: Array, default: () => [] },
    loading: { type: Boolean, default: false },
    instructors: { type: Array, default: () => [] },
  },

  data() {
    return {
      search: "",
      filterInstructorId: null,
      headers: [
        { text: "ID", value: "enrolment_id", width: "70px" },
        { text: "Learner ID", value: "learner_id", width: "100px" },
        { text: "Learner", value: "learner" },
        { text: "Instructor ID", value: "adi_id", width: "100px" },
        { text: "Instructor", value: "adi" },
        { text: "Syllabus ID", value: "syllabus_id", width: "110px" },
        { text: "Status", value: "is_current", sortable: false, width: "100px" },
        { text: "Enrolled On", value: "created_on", width: "160px" },
      ],
    };
  },

  computed: {
    filteredItems() {
      if (!this.filterInstructorId) return this.items;
      return this.items.filter((i) => i.adi_id === this.filterInstructorId);
    },
  },
};
</script>
